(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_b63fcf8"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('store-locations-carousel')) {
    class StoreLocationsCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        this.prev = this.querySelector('[data-carousel-prev]');
        this.next = this.querySelector('[data-carousel-next]');
        this.dotsContainer = this.querySelector('[data-carousel-dots]');
        this.cards = Array.from(this.track.children);
        if (!this.cards.length) return;

        this.prev?.addEventListener('click', () => this.scrollByCards(-1));
        this.next?.addEventListener('click', () => this.scrollByCards(1));
        this.track.addEventListener('scroll', () => this.update(), { passive: true });
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);

        this.buildDots();
        this.update();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      get step() {
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return this.cards[0].offsetWidth + gap;
      }

      scrollByCards(direction) {
        this.track.scrollBy({ left: direction * this.step, behavior: 'smooth' });
      }

      buildDots() {
        if (!this.dotsContainer) return;
        this.dots = this.cards.map((card, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'slc__dot';
          dot.setAttribute('aria-label', `Go to store ${index + 1}`);
          dot.addEventListener('click', () => {
            this.track.scrollTo({ left: index * this.step, behavior: 'smooth' });
          });
          return dot;
        });
        this.dotsContainer.replaceChildren(...this.dots);
      }

      update() {
        const { scrollLeft, clientWidth, scrollWidth } = this.track;
        const active = Math.round(scrollLeft / this.step);
        this.dots?.forEach((dot, index) => dot.setAttribute('aria-current', index === active));
        if (this.prev) this.prev.disabled = scrollLeft <= 0;
        if (this.next) this.next.disabled = scrollLeft + clientWidth >= scrollWidth - 1;
      }
    }

    customElements.define('store-locations-carousel', StoreLocationsCarousel);
  }
  } catch(e) { console.error(e); }
})();

})();
